import { createRunMutationAction } from '@/store/utils';
import * as types from '@/store/issue/actionTypes';
import {
  SET_ISSUES,
  CLEAR_ISSUES,
  SET_ISSUE_LIST_OPTIONS,
  SET_ISSUES_INNER_DATA,
  CLEAR_ISSUES_INNER_DATA,
  SET_ISSUE_DETAILS,
  CLEAR_ISSUE_DETAILS,
} from '@/store/issue/mutationTypes';
// eslint-disable-next-line import/no-cycle
import {
  loadIssues,
  loadIssuesInnerData,
  addNewIssue,
  changeIssueStatus,
  getIssueDetails,
  addNewIssueBySP,
  changeIssueStatusBySP,
  loadIssuesBySP,
  getIssueDetailsForSP,
  loadIssuesInnerDataForSP,
  deleteIssueBySP,
  editIssueBySP,
} from '@/services/repository';

export default {
  async [types.LOAD_ISSUES]({ commit, getters }, options) {
    try {
      let issuesResponse;
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        issuesResponse = await loadIssuesBySP(getters.issueListOptions, options);
      } else {
        issuesResponse = await loadIssues(getters.issueListOptions, options);
      }
      const { items: issues } = issuesResponse;
      commit(SET_ISSUES, issues);
    } catch (e) {
      console.error('Load issues error:', e);
      commit(CLEAR_ISSUES);
      throw e;
    }
  },
  [types.CLEAR_ISSUES]: createRunMutationAction(CLEAR_ISSUES),
  async [types.CHANGE_ISSUE_LIST_OPTIONS]({ commit, dispatch }, options) {
    commit(SET_ISSUE_LIST_OPTIONS, options);
    await dispatch(types.LOAD_ISSUES, { projectId: options.projectId });
  },
  async [types.LOAD_ISSUES_INNER_DATA]({ commit, getters }) {
    try {
      let issuesInnerData;
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        issuesInnerData = await loadIssuesInnerDataForSP();
      } else {
        issuesInnerData = await loadIssuesInnerData();
      }
      commit(SET_ISSUES_INNER_DATA, issuesInnerData);
    } catch (e) {
      console.error('Load issues inner data error:', e);
      commit(CLEAR_ISSUES_INNER_DATA);
      throw e;
    }
  },
  async [types.ADD_ISSUE]({ dispatch, getters }, options) {
    try {
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        await addNewIssueBySP(options.newIssue);
      } else {
        await addNewIssue(options.newIssue);
      }
    } catch (e) {
      console.error('Add new issue error:', e);
      throw e;
    }
    await dispatch(types.LOAD_ISSUES, { projectId: options.newIssue.projectId });
  },

  async [types.CHANGE_ISSUE_STATUS]({ dispatch, getters }, options) {
    try {
      let updatedIssue;
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        updatedIssue = await changeIssueStatusBySP(options.issueId, options.status);
      } else {
        updatedIssue = await changeIssueStatus(options.issueId, options.status);
      }
      await dispatch(types.LOAD_ISSUES, { projectId: options.projectId });
      return updatedIssue;
    } catch (e) {
      console.error('Change issues status error:', e);
      throw e;
    }
  },

  async [types.LOAD_ISSUE_DETAILS]({ commit, getters }, options) {
    try {
      let issueDetails;
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        issueDetails = await getIssueDetailsForSP(options.issueId);
      } else if (options.issueId) {
        issueDetails = await getIssueDetails(options.issueId);
      }
      commit(SET_ISSUE_DETAILS, issueDetails);
    } catch (e) {
      console.error('Get issues details error:', e);
      commit(CLEAR_ISSUE_DETAILS);
      throw e;
    }
  },
  [types.CLEAR_ISSUE_DETAILS]: createRunMutationAction(CLEAR_ISSUE_DETAILS),

  async [types.DELETE_ISSUE]({ dispatch }, options) {
    try {
      await deleteIssueBySP(options.issueId);
    } catch (e) {
      console.error('Delete issue error:', e);
      throw e;
    }
    await dispatch(types.LOAD_ISSUES, { projectId: options.projectId });
  },

  async [types.EDIT_ISSUE]({ dispatch }, options) {
    try {
      const updatedIssue = await editIssueBySP(options.issueId, options.issue);
      await dispatch(types.LOAD_ISSUES, { projectId: options.projectId });
      return updatedIssue;
    } catch (e) {
      console.error('Change issue error:', e);
      throw e;
    }
  },

};
